import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';
import WindowBrowser from "../components/browser-window";


const LabGoals = () => {
    const headers = ['Lab Goals'];

    useEffect(() => {


    }, [])

    return (
        <div className="simple_page">
            <div className="mainIntro">
                <h1>Lab Goals</h1>
                <h3>Spot the Fake. Safeguard the Cure.</h3>
            </div>
            <section className="divider">
                <div className="fixed_sidebar">
                    <div className="sidebar">
                        <div className="main_sidebar">
                            Lab Goals
                        </div>

                        <Scrollspy
                            offset={-140}
                            className="scrollspy" items={['CompareAptamer', 'ExamineBindingConstants', 'EvaluatePerformance', 'DevelopDevice']}
                            currentClassName="active">

                            <li><a href="#CompareAptamer">1. Compare the obtained aptamer with the original</a></li>
                            <li><a href="#ExamineBindingConstants">2. Examine Binding Constants</a></li>
                            <li><a href="#EvaluatePerformance">3. Evaluate the aptamer's performance using ELONA (Enzyme-Linked Oligonucleotide Assay)</a></li>
                            <li><a href="#DevelopDevice">4. Develop a semi-quantitative device for Bevacizumab detection via an LFA competitive format based on the new aptamer (CU2#19)</a></li>

                        </Scrollspy>
                        {/* <Scrollspy
              offset={-140}
              className="scrollspy" items={
                headers.map(header => {
                  return header.split(' ')[0]
                })
              }
              currentClassName="active">
              {
                headers.map(header=>{
                   
                  return (
                    <li><a href={"#"+header.split(' ')[0]}>{
                      header.replace('_', '')
                    }</a></li>
                  )
                  
                })
              }
            </Scrollspy> */}

                        <img
                            src="https://static.igem.wiki/teams/5334/wiki-images/updated-mascot/mascot-holding-flask-3-1.webp"
                            alt="Mascot is hoding flask"
                        />

                    </div>

                </div>
                <div className="main_lab_style">
                    <WindowBrowser header="Lab Goals" description={
                        <>
                            <div style={{ display: 'none' }}>
                                {
                                    headers.map(header => {
                                        return (
                                            <section href={header.split(' ')[0]}>{
                                                header
                                            }</section>
                                        )

                                    })
                                }
                            </div>

                            <section id="CompareAptamer">
                                <h1> 1. Compare the obtained aptamer with the original</h1>
                                <p>
                                    Evaluate the structural and functional properties of the modified aptamer (CU2#19) relative to the original version (A14#1) using structural analysis and molecular dynamics methods. This comparison is crucial for ensuring that the aptamer maintains its efficacy and specificity for Bevacizumab.
                                </p>
                            </section>
                            <section id="ExamineBindingConstants">
                                <h1>2. Examine binding constants</h1>
                                <p>
                                    Compare the affinity of the anti-idiotypic aptamer for Bevacizumab by determining binding constants. We will use MicroScale Thermophoresis (MST) to measure the binding kinetics and affinities of the aptamer. MST is highly sensitive and requires only minimal sample amounts, making it ideal for studying aptamer-protein interactions in solution under near-physiological conditions. MST also allows us to monitor binding events with high precision without the need for immobilization, which preserves the natural structure and dynamics of the aptamer.</p>
                            </section>



                            <section id="EvaluatePerformance">
                                <h1>3. Evaluate the aptamer's performance using ELONA (Enzyme-Linked Oligonucleotide Assay)</h1>
                                <p>
                                    This method will be employed to validate the aptamer's sensitivity to Bevacizumab. We chose ELONA due to its versatility in detecting small molecules and its ability to amplify weak signals through enzymatic reactions. This makes it a highly sensitive approach to quantify the aptamer-Bevacizumab interaction. By combining ELONA with MST, we can gain both qualitative (specificity) and quantitative (binding strength) insights into the aptamer's performance. These complementary methods ensure that the aptamer is effective for use in the LFA test strip for counterfeit Bevacizumab detection.
                                </p>

                            </section>

                            <section id="DevelopDevice">

                                <h1>4. Develop a semi-quantitative device for Bevacizumab detection via an LFA competitive format based on the new aptamer (CU2#19)
                                </h1>
                                <p>
                                    This goal focuses on creating a semi-quantitative lateral flow assay (LFA) for Bevacizumab detection using the modified aptamer (CU2#19) in a competitive format. Gold nanoparticles will be used to provide a visual readout by labeling the aptamer-Bevacizumab complexes, allowing for easy detection of the signal. The competitive format will involve Bevacizumab competing with a labeled version for binding to the aptamer, with signal intensity inversely proportional to the concentration of Bevacizumab in the sample. Additionally, the control line in the LFA will incorporate the 24xT aptamer, ensuring that the device is functioning correctly by generating a strong signal at the control line regardless of the Bevacizumab concentration. This system ensures the test is reliable, sensitive, and suitable for detecting counterfeit Bevacizumab in real-world applications.

                                </p>

                                <br></br>
                                <br></br>

                                <p>
                                    By employing MST and ELONA, we ensure a comprehensive evaluation of both the binding dynamics and sensitivity of the aptamer, making these techniques ideal for developing a reliable LFA test strip.
                                </p>
                                <br></br>
                                <br></br>


                            </section>
                        </>
                    } />
                </div>
            </section>
        </div>
    );
}

export default LabGoals;
